import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { Routing } from './routes';
import { Ng2PageScrollModule } from 'ng2-page-scroll';
import { MiscService } from './services/misc.service';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FrontpageComponent } from './frontpage/frontpage.component';
import { PageComponent } from './page/page.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    FrontpageComponent,
    PageComponent
  ],
  imports: [
    BrowserModule,
    Routing,
    NgbModule.forRoot(),
    Ng2PageScrollModule
  ],
  providers: [
    MiscService
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/ilu/projektit/ets-tuloksia/src/app/app.module.ts